module.exports = __webpack_public_path__ + "media/assets/icons/infonoid_logo_white-f7ed855c97b7a4d833e3b4ed3ba3f5ed.svg";